import React, { useState, useEffect } from 'react';
import { BACKEND_URL } from '@/lib/env';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import EnhancedTicketDetail from './EnhancedTicketDetail';
import ErrorTicketDetail from './ErrorTicketDetail';
import { Loader2 } from 'lucide-react';

const API = `${BACKEND_URL}/api`;

export default function TicketDetailRouter() {
  const { id } = useParams();
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTicket();
  }, [id]);

  const fetchTicket = async () => {
    try {
      // id from useParams is ticket_number
      const ticketNumber = id;
      const response = await axios.get(`${API}/tickets/${ticketNumber}`);
      setTicket(response.data);
    } catch (error) {
      console.error('Error fetching ticket:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  if (!ticket) {
    return <div className="flex items-center justify-center h-full">Ticket not found</div>;
  }

  // Route to specialized view based on ticket type
  if (ticket.is_error_ticket) {
    return <ErrorTicketDetail />;
  } else {
    return <EnhancedTicketDetail />;
  }
}
